import { authConstants, userConstants } from '../constants';
import { authService } from '../services';

import { history } from '../helpers';

const login = (username, password) => {
  const request = () => ({ type: authConstants.LOGIN_REQUEST });
  const success = (user) => ({ type: authConstants.LOGIN_SUCCESS, user });
  const failure = (error) => ({ type: authConstants.LOGIN_FAILURE, error });

  const setUser = (user) => ({ type: userConstants.SET_USER, user });

  return dispatch => {
    dispatch(request())
    authService.login({ username, password })
      .then(res => {
        const { data: token, courseCode, message, membershipExpired } = res.data;
        if (!!token ) {
          const user = { token, courseCode };
          localStorage.setItem('currentUser', JSON.stringify(user));
          dispatch(success(user));
          dispatch(setUser(user));
          history.replace("/");
        }
        else {
          dispatch(failure({
            membershipExpired,
            message
          }));
        }
      })
      .catch(err => {
        dispatch(failure(err));
      });
  }
}

const logout = () => {
  const signout = () => ({ type: authConstants.LOGOUT });
  const setUser = (user) => ({ type: userConstants.SET_USER, user });

  return dispatch => {
    authService.logout()
      .then(res => {
        localStorage.removeItem('currentUser');
        dispatch(setUser({}));
        dispatch(signout());
      })
      .catch(err => {
      });
  }
}

export const authActions = {
  login,
  logout
}
